import styled from 'styled-components'

import { TrackingWalletFollowingUpdateCardBody } from './tracking-wallet-following-update-card-body'
import { TrackingWalletFollowingUpdateCardHeader } from './tracking-wallet-following-update-card-header'

import type { TrackedWalletSwapAlert } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  trade: TrackedWalletSwapAlert.Alert
} & ClassNameProps

export const TrackingWalletFollowingUpdateCard: React.FC<Props> = ({
  className,
  trade,
}) => {
  return (
    <Root className={className}>
      <TrackingWalletFollowingUpdateCardHeader trade={trade} />
      <TrackingWalletFollowingUpdateCardBody trade={trade} />
    </Root>
  )
}

const Root = styled.div`
  height: 100px;
  padding-block: 12px;
  padding-inline: 12px;
  display: grid;
`
